import React from 'react';
import styles from './QtyControl.module.css';

export default function QtyControl({ value, onChange, size = 'md' }) {
  return (
    <div className={`${styles.ctrl} ${styles[size]}`}>
      <button
        className={styles.btn}
        onClick={() => onChange(Math.max(0, value - 1))}
        aria-label="Diminuir"
      >
        −
      </button>
      <span className={styles.num}>{value}</span>
      <button
        className={styles.btn}
        onClick={() => onChange(value + 1)}
        aria-label="Aumentar"
      >
        +
      </button>
    </div>
  );
}
